
import { MenuListItemComponent } from './features/ui/menu-list-item/menu-list-item.component';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { FeaturesComponent } from './features/features.component';
import { MaterialModule } from './material/material.module';
import { HttpErrorInterceptor } from './services/interceptors/httpinterceptor';
import { Aggrement } from './popupmodal/aggregatorcomponent/aggreement/aggreement.component';
import { ListmodalComponent } from './popupmodal/nccf/Viewlist/listmodal.component';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { NgxUiLoaderConfig, NgxUiLoaderModule } from 'ngx-ui-loader';
import { FlexLayoutModule } from '@angular/flex-layout';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ToastrModule } from 'ngx-toastr';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { AutocompleteLibModule } from 'angular-ng-autocomplete';
import { UploaderrorreportComponent } from './popupmodal/customercomponent/uploaderrorreport/uploaderrorreport/uploaderrorreport.component';
import { NgChartsModule } from 'ng2-charts';
import { ChartModule } from 'angular2-chartjs';
import { PrimeNgModule } from './primengmodule/primemodule.module';

const ngxUiLoaderConfig: NgxUiLoaderConfig = {
  "bgsColor": "#3f51b5",
  "bgsPosition": "bottom-right",
  "bgsSize": 20,
  "bgsType": "ball-spin-clockwise",
  "blur": 5,
  "delay": 0,
  "fastFadeOut": true,
  "fgsColor": "#3f51b5",
  "fgsPosition": "center-center",
  "fgsSize": 40,
  "fgsType": "rectangle-bounce",
  "gap": 10,
  "logoPosition": "center-center",
  "logoSize": 120,
  "logoUrl": "",
  "masterLoaderId": "master",
  "overlayBorderRadius": "0",
  "pbColor": "#3f51b5",
  "pbDirection": "ltr",
  "pbThickness": 6,
  "hasProgressBar": true,
  "text": "",
  "textColor": "#FFFFFF",
  "textPosition": "center-center",
  "maxTime": -1,
  "minTime": 300
};

@NgModule({
  declarations: [
        AppComponent,
        MenuListItemComponent,
        FeaturesComponent,
        Aggrement,
        ListmodalComponent,
        UploaderrorreportComponent,
  ],
  imports: [
      BrowserModule,
      BrowserAnimationsModule,
      FlexLayoutModule,
      HttpClientModule,
      AppRoutingModule,
      MaterialModule,
      FormsModule,
      NgxIntlTelInputModule,
      ReactiveFormsModule,
      OwlDateTimeModule,
      OwlNativeDateTimeModule,
      ToastrModule.forRoot(
        {timeOut:3000,
        closeButton: true,
        progressBar: true,
        positionClass: 'toast-top-right',
        preventDuplicates: true
      }),
      NgxUiLoaderModule.forRoot(ngxUiLoaderConfig),
      AutocompleteLibModule,
      NgChartsModule,
      ChartModule,
      PrimeNgModule
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpErrorInterceptor,
      multi: true
    }
  ],
  bootstrap: [AppComponent],
  schemas:[CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule { }
